<template lang='pug'>
  v-container.pt-1(fill-height)
    v-row(align='center' justify='center').fill-height
      v-col(align='center' justify='center')
        bionic-metrics-spinner
        .text-h5.grey--text(v-if='title') {{title}}
</template>

<script>
import BionicMetricsSpinner from './Spinner';

export default {
  name: 'BionicMetricsPageLoading',
  props: {
    title: {
      type: String
    }
  },
  components: {BionicMetricsSpinner},
  methods: {},
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
